export const customerCards = [
  {
    name: 'seniors_go_card_no',
    label: 'Seniors card <i>+go</i>',
    image: 'seniors-go-card.png',
    checked: false
  },
  {
    name: 'business_discount_card_no',
    label: 'Seniors business discount card',
    image: 'seniors-business-discounts-card.png',
    checked: false
  },
  {
    name: 'seniors_card_no',
    label: 'Seniors card',
    image: 'seniors-card.png',
    checked: false
  },
  {
    name: 'carer_card_no',
    label: 'Carers card',
    image: 'scarers-card.png',
    checked: false
  },
  {
    name: 'pensioner_card_no',
    label: 'Pensioner concession card',
    image: 'pensioner-card.png',
    checked: false
  }
];



// WEBPACK FOOTER //
// ./app/shared/customer-cards.ts